import { BreakCommon } from "./BreakCommon";
import { kDefaultBreakChars } from "../constants";
import { BreakContentList } from "./BreakContentList";

export function BreakContent(
  theContent,
  maxRows,
  availableWidth,
  leftMargin,
  rightMargin,
  fontString,
  breakChars
) {
  if (breakChars == "!")
    return BreakContentList(theContent, availableWidth, leftMargin, rightMargin, fontString);

  var contentRows = [];
  //var numRows = 0;
  if (maxRows == 1 || theContent.length == 0) contentRows.push(theContent);
  else {
    availableWidth = availableWidth - (rightMargin + leftMargin);

    //var done = false;
    if (breakChars == null) breakChars = "";

    var regStr = "[" + kDefaultBreakChars + breakChars + "]";
    var re = new RegExp(regStr);

    BreakCommon(theContent, re, availableWidth, fontString, maxRows, contentRows);
  }

  return contentRows;
}
